exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-search {\r\n    margin-top: 15px;\r\n}\r\n\r\ndynamic-form {\r\n    margin-top: 0px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.merge-alert{\r\n    margin-top: 15px;\r\n}\r\n\r\ndynamic-form /deep/ .form-control[disabled] {\r\n    background-color: #eee;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/views/admin/customer/customer-merge.css
// module id = 976
// module chunks = 0